<template>
  <div id="buy">
    <div class="buy_nav"></div>
    <div class="buy_container">
      <div class="buy_containers">
        <div class="buy_title">购买</div>
        <div class="buy_detail" style="margin-top:34px">
          <!-- <p class="title">模拟版功能列表</p> -->
          <!-- <tr class="firstline lightTr">
              <td rowspan="2">F10资料</td>
              <td class="left">公司资料：股本结构、股东信息、员工构成、行业地位、资产交易、项目投资、参股控股</td>
              
              
            </tr>
           
            <tr class="lightTr">
              <td class="left">财务数据：财务速览、数据分解、杜邦分析、主营构成、原始财务报表、财务附注</td>
              
              
            </tr> -->
          <table class="buytable">
            <tr>
              <td width="105px">模块</td>
              <td width="145px">类别</td>
              <td>内容</td>
              <td width="110px">5E基础版</td>
              <!-- <td width="85px">5C标准版 </td> -->
              <!-- <td width="90px" style="background:#c75438;color:white">标准版</td>
              <td width="90px" style="background:#c75438;color:white">券商定制版</td> -->
            </tr>
            <tr class="firstline">
              <td rowspan="5">资讯链</td>
              <td style="padding-left:0;text-align:center">新闻</td>
              <td class="left">资讯、公告、研报、大事件</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="firstline">
              <td>资金流向</td>
              <td class="left">超大单、大单、中单、小单流入/流出</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <!-- <tr class="firstline">
              <td>财务评级</td>
              <td class="left">现金支持、利润质量、营运能力、偿债保障、资产质量</td>
              <td>√</td>
              <td>√</td>
            </tr> -->
            <tr class="firstline">
              <td>财务简报</td>
              <td class="left">总股本、市净率、净资产、现金流量净额、销售利率、ROE（摊薄）、<br><sup style="position:relative;top:-4px">...</sup></td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="firstline">
              <td>事件库</td>
              <td class="left">重大事件</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="firstline">
              <td>分红库</td>
              <td class="left">分红数据</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="firstline lightTr">
              <td rowspan="4">F10资料</td>
              <td style="padding-left:0;text-align:center">公司资料</td>
              <td class="left">股本结构、股东信息、员工构成、行业地位、资产交易、项目投资、<br>参股控股</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="firstline lightTr">
              <td style="padding-left:0;text-align:center">财务数据</td>
              <td class="left">财务速览、数据分解、杜邦分析、主营构成、原始财务报表、财务附注、<br>业绩预披露</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="firstline lightTr">
              <td>业绩预期</td>
              <td class="left">预期数据、 DCF估值</td>
              <td>√</td>
              <!-- <td>√</td> -->
              
            </tr>
            <tr class="firstline lightTr">
              <td>二级市场</td>
              <td class="left">龙虎榜单、大宗交易、融资融券、北向资金</td>
              <td>√</td>
              <!-- <td>√</td> -->
              
            </tr>

            <tr class="firstline ">
              <td rowspan="5">财务分析</td>
              <td style="padding-left:0;text-align:center">深加工数据</td>
              <td class="left ">财务表现排名</td>
              <td>√</td>
              <!-- <td>√</td> -->
              
            </tr>
            <tr class="firstline ">
              <td style="padding-left:0;text-align:center">统计工具</td>
              <td class="left">截面统计、选股</td>
              <td>√</td>
              <!-- <td>√</td> -->
          
            </tr>
            <tr class="firstline ">
              <td style="padding:21px 0 !important;text-align:center">估值数据<span style="position:relative"><img src="../../assets/img/yuanchuang.png" alt=""  class="yuanchaung"/></span></td>
              <td class="left">小文估值</td>
              <td>√</td>
              <!-- <td>√</td> -->
          
            </tr>
            <!-- <tr class="firstline lightTr">
              <td>宏观分析工具</td>
              <td class="left">重点数据、板块聚焦、周期与趋势、市场相关性、北向资金、融资融券、基金重仓、货币流动性、宏观经济</td>
              
              
            </tr> -->
            
            <tr class="firstline ">
              <td>个股研究</td>
              <td class="left " style="padding-left:10px !important">
              财务画像、利润滤镜、风险甄别

              <!-- 、风险信号灯 -->
              </td>
              <td>√</td>
              <!-- <td>√</td> -->
              
            </tr>
            <tr class="firstline ">
              <td>股息率</td>
              <td class="left " style="padding:10px 0 !important;padding-left:10px !important">
             股息率分析、增发概况、配股明细、DDM估值
              </td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>

          
            <tr class="firstline lightTr">
              <td rowspan="8">扩展研究</td>
              <td class="firstline lightTr" rowspan="2" style="padding:0;text-align:center">全市场<br>数据统计</td>
              <td class="left">基金重仓、融资融券、北向资金</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <!-- <tr class="lightTr">
              <td class="left">宏观研究：周期与趋势、市场相关性</td>
              
              
            </tr> -->
            <tr class="lightTr"> 
              <td class="left ">指标类数据：市场活力指数、腾落指数、文华股市景气指数、<br>商品预期指数</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="lightTr">
              <td class="firstline lightTr" rowspan="5" style="padding:0;text-align:center">行业板块研究</td>
              <td class="left">市场表现：股价表现、财务表现、资金流向、相关矩阵</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="lightTr">
              <td class="left">行业估值：估值驱动因素、估值水平、估值/业绩比较</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="lightTr">
              <td class="left ">上市公司：公司统计</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="lightTr">
              <td class="left">行业研究热度：研报统计、调研统计</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
             <tr class="lightTr">
              <td class="left ">轮动分析：宏观周期与板块轮动、景气度轮动、业绩预测轮动、<br>预期差轮动、资金偏好轮动、趋势轮动、风格轮动</td>
              <td>√</td>
              <!-- <td>√</td> -->

            </tr>
            <tr class="lightTr">
              <td  style="padding:0;text-align:center">宏观数据</td>
              <td class="left" >经济数据、货币数据、周期性研究、相关性研究</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <!-- <tr class="lightTr">
              <td class="firstline" style="padding:0;text-align:center">一篮子<br>股票分析工具</td>
              <td class="left leftyc">对比分析、历史分析<span style="position:relative"><img src="../../assets/img/yuanchuang.png" alt=""  class="yuanchaung"/></span></td>
            </tr> -->
            <tr class="firstline">
              <td rowspan="2" style="padding:10px !important;text-align:center">自选<br>分析工具</td>
              <td class="firstline" style="padding:10px;text-align:center">净值曲线<br>历史分析</td>
              <td class="left">组合分析、净值k线图、盈亏分析、行业分析</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr class="firstline">
              <td class="firstline" >对比分析</td>
              <td class="left">财务表现、经营数据、偿债能力、银行专项</td>
              <td>√</td>
              <!-- <td>√</td> -->
            </tr>
            <tr>
                <td colspan="3" style="text-align:right">数据服务费（元/年/账号）</td>
                <td  style="color: rgb(202, 67, 67);font-weight: bold;font-size: 18px;padding:10px 0;border-left: none;text-align:center;padding-right:0">免费</td>
                <!-- <td style="color: rgb(202, 67, 67);font-weight: bold;font-size: 18px;text-align:center;">{{filterPrice(820)}}</td> -->
            </tr>

            <!-- <tr class="firstline">
              <td> 售后服务</td>
              <td colspan="2" class="left" style="padding:20px">
               专属的金融工程师、辅助编写模型、<a href="https://www.wenhua.com.cn/Home/wwt" target="_blank" style="color:#3888ff">文文通</a>即时服务
              </td>
              
            </tr> -->
            <!-- <tr class="firstline">
              <td colspan="3" style="padding:20px 0 !important;text-align:right">
               以上打勾功能服务费（年/账号）
              </td>
              <td style="color:#ca4343;font-weight:bold;font-size:18px">免费</td>
              <td style="color:#ca4343;font-weight:bold;font-size:18px">10800元</td>
            </tr> -->
          </table>
          <p class="title">另外选配的数据</p>
          <table class="buytable buytable2" style="width: 600px">
            <tr>
              <td width="160px">数据名称</td>
              <td width="160px">
                <span style="font-size: 18px">价格</span>
              <span style="font-size: 14px">(元/年/账号)</span>
              </td>
            </tr>
            <tr>
              <td>香港股票（仅境内查看）</td>
              <td>+{{filterPrice(624)}}（个人）/{{filterPrice(624,1)}}（公司）</td>
            </tr>
            <tr>
              <td>香港股票（需境外查看）</td>
              <td>+{{filterPrice(623)}}</td>
            </tr>
            <tr>
              <td>美国股票</td>
              <td>+{{filterPrice(622)}}</td>
            </tr>
          </table>
          <p class="zhushi" style="margin-top:7px">
            注：选配数据是指在<common-data name="appShortName_26" v-common-display/>软件默认的数据基础上可另外付费选择增加的数据授权。
          </p>
          <div style="height:90px;margin-top: 65px;margin-right:27px">
              <div style="float:left;margin-top:22px;font-size:14px;">咨询电话：<common-data name="serviceTel" v-common-display/></div>
              <a style="background:#de7b62;width:120px;height:45px;border-radius:5px;text-align:center;line-height:45px;float:right;text-decoration: none;color:white" href="https://pay.wenhua.com.cn/#/detail/129" target="_blank">
                去购买
              </a>
          </div>
          <!-- <p class="zhushi">注：券商定制版<common-data name="appShortName_26" v-common-display/>不支持文件下单、算法拆单及研报模块。</p> -->
            <!-- <div>
            <p class="title">另外选配的数据</p>
            <table class="buytable buytable2" style="width: 600px">
              <tr>
                <td width="160px">数据名称</td>
                <td width="160px">
                  <span style="font-size: 18px">价格</span>
                <span style="font-size: 14px">(元/年/账号)</span>
                </td>
              </tr>
              <tr>
                <td>香港股票（仅境内查看）</td>
                <td>+1200/1500（公司）</td>
              </tr>
              <tr>
                <td>香港股票（需境外查看）</td>
                <td>+3000</td>
              </tr>
              <tr>
                <td>美国股票</td>
                <td>+480</td>
              </tr>
            </table>
            <p class="zhushi">
              注：选配数据是指在<common-data name="appShortName_26" v-common-display/>软件默认的数据基础上可另外付费选择增加的数据授权。
            </p>
            <div style="height:90px;margin-top: 13px;">
              <a style="background:#de7b62;width:120px;height:45px;border-radius:5px;text-align:center;line-height:45px;float:right;text-decoration: none;color:white" href="https://pay.wenhua.com.cn/#/detail/128" target="_blank">
                订购
              </a>
            </div>
          </div> -->
        </div>
      </div>

      <cont
        v-if="showcont"
        :txt="showcont"
        v-on:txt="close($event)"
        :tt="tt"
      ></cont>
      <hovertip v-if="showhover" style="position:fixed" :style="{left:left+'px',top:top+'px'}" :text="wenan"></hovertip>
    </div>
  </div>
</template>

<script>
import hovertip from "./frame/hovertip";
import cont from "./frame/cont";
import axios from "axios";
export default {
  data() {
    return {
      left:'',
      top:'',
      showhover:false,
      showcont: false,
      sf: "- 省份 -",
      cs: "- 城市 -",
      sfli: [],
      csfi: [],
      ind: "",
      ifla: false,
      iflacs: false,
      tt: "",
      yuyueShow: false,
      wenanlist:[
        { 
          text1:'国金证券不提供：算法拆单、文件下单',
          text2:'平安证券不提供：文件下单',
        },
        {
          text1:'国金证券不提供：研报',
          text2:'',
        }
      ],
      wenan:{},
      webMarketPrice:[],
    };
  },
  components: {
    cont,hovertip
  },
  methods: {
    close(e) {
      this.showcont = e;
    },
    showtip(e,txt){
      console.log(txt)
      this.wenan=txt
      this.showhover=true
      console.log(e.target.getBoundingClientRect())
      this.left=e.target.getBoundingClientRect().left
      this.top=e.target.getBoundingClientRect().top
    },
    hidetip(){
      this.showhover=false
    },
    lianxi(t) {
      this.tt = t;
      this.showcont = true;
      //  var a= document.getElementsByTagName("html")[0]
      var mask_bg = document.createElement("div");
      mask_bg.id = "mask_bg";
      mask_bg.style.position = "fixed";
      mask_bg.style.top = "0px";
      mask_bg.style.left = "0px";
      //  mask_bg.style.right = "0px";
      // mask_bg.style.bottom = "0px";
      mask_bg.style.width = "100%";
      mask_bg.style.height = "100%";
      mask_bg.style.backgroundColor = "#777";
      mask_bg.style.opacity = 0.6;
      mask_bg.style.zIndex = 1111111;
      document.body.appendChild(mask_bg);
      var alertcont = document.createElement("cont");
      mask_bg.appendChild(alertcont);
    },

    huoqusf() {
      axios.get("//wh-api.wenhua.com.cn/api/Roadshow/GetProv").then((res) => {
        if (res.data.status) {
          for (var a = 0; a < res.data.data.length; a++) {
            this.sfli.push(res.data.data[a]);
          }
        }
      });
    },
    sfxl() {
      this.ifla = !this.ifla;
    },
    csxl() {
      this.iflacs = !this.iflacs;
    },
    buystop() {
      this.lianxi("暂未开放购买");
    },
    choose(idx) {
      this.sf = this.sfli[idx].prov;
      this.ind = idx + 1;
      this.csfi = [];
      this.csfi = this.sfli[idx].regions;
    },
    choosecs(idx) {
      this.cs = this.csfi[idx].regioN_NAME;
    },
    tijiao() {
      var name = document.getElementById("names").value;
      var tel = document.getElementById("tel").value;
      var comp = document.getElementById("comp").value;
      if (name == "") {
        this.lianxi("请输入姓名");
        return;
      }
      if (tel == "") {
        this.lianxi("请输入手机号");
        return;
      }
      if (comp == "") {
        this.lianxi("请输入公司名称");
        return;
      }
      if (this.sf == "- 省份 -") {
        this.lianxi("请选择省份");
        return;
      }
      if (this.cs == "- 城市 -") {
        this.lianxi("请选择城市");
        return;
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(tel)) {
        this.lianxi("手机号码格式不正确");

        return false;
      }
      console.log(this.sf);
      axios
        .post("//wh-api.wenhua.com.cn/api/Roadshow/CreateRoadshow", {
          name: name,
          phone: tel,
          companyName: comp,
          province: this.ind,
          ProvinceName: this.sf,
          regionName: this.cs,
        })
        .then((res) => {
          if (res.status) {
            this.lianxi("提交成功");
          } else {
            this.lianxi("提交失败，请重试");
          }
        });
    },
    filterPrice(id,company){
      return company&&this.webMarketPrice.length>0?this.webMarketPrice.filter((el)=>{
              return el.id==id
            })[0].majorprice:this.webMarketPrice.length>0?this.webMarketPrice.filter((el)=>{
              return el.id==id
            })[0].price:'加载中'        
    },
    setPrice(){
      axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=129').then((res) => {
          if (res.data.status) {
            this.webMarketPrice = res.data.data.sublist
            
          } else {
            alert(res.data.message)
          }
        });
    }
  },
  mounted() {
    this.huoqusf();
    window.addEventListener("click", (e) => {
      if (this.$refs.cs && !this.$refs.cs.contains(e.target)) {
        this.iflacs = false;
      }
      if (this.$refs.sf && !this.$refs.sf.contains(e.target)) {
        this.ifla = false;
      }
    });
  },
  created(){
    this.setPrice()
  }
};
</script>

<style scoped>
.xing{
  cursor: pointer;
  /* pointer-events:none; */
  user-select: none;
}
.xing span{
  color: red;
  cursor: pointer;
  user-select: none;
}
.daozhuan{
      transform: rotateX(180deg);
}
.leftyc{
    padding: 21px 0!important;
}
.left {
  text-align: left !important;
  padding-left: 10px !important;
}
.href {
  color: #3888ff;
  /* text-decoration: underline; */
  cursor: pointer;
  font-size: 14px;
  margin-left: 20px;
  vertical-align: middle;
}
.title {
  margin-top: 30px;
  font-size: 18px;
  color: #666;
  font-weight: bold;
}
.buytable {
  margin-top: 15px;
}

.buytable tr {
  /* height: 35px; */
  vertical-align: middle;
  color: #4c4c4c;
  font-size: 14px;
}
.buytable tr:first-child > td {
  padding: 5px 0 !important;
  line-height: 24px;
}
.buytable td {
  padding: 8px 0;
  padding-left: 50px;
  vertical-align: middle;
  line-height: 20px;
  color: #4d4d4d;
}
.buytable2 td{
  line-height: 20px;
  padding: 8px 0 !important;
}
.lightTr {
  background: #f7f7f7;
}
.buytable tr:first-child {
  /* height: 40px;
  line-height: 40px; */
  background: #c75438;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.buytable tr:first-child td {
  padding-left: 0;
  color: inherit;
}
.buytable tr td:nth-last-child(1) {
  /* background: #fef7fa; */
  text-align: center;
  padding: 10px 10px;
}
.buytable tr td:nth-last-child(2) {
  /* background: #fef7fa; */
  text-align: center;
  padding: 10px 10px;
}
.firstline td:first-child {
  text-align: center;
  padding: 0 !important;
}
/*.firstline td:nth-child(2){
  background: none  !important;
}
.firstline td:nth-child(3){
  background: #fef7fa !important;
}
.firstline td:nth-child(4){
  background: #fffff9;
} */
.col td {
  background: white !important;
  text-align: left !important;
  padding-left: 50px !important;
}
/* .col td:last-child {
  padding-left: 90px !important;
} */
#buy {
  position: relative;
  color: #7b7b7b;
}
.buy_nav {
  height: 488px;
  width: 100%;
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=13) no-repeat center top;
}
.buy_container {
  width: 1050px;
  height: 100%;
  position: relative;
  margin: -252px auto 0 auto;

  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 0 20px -5px #ccc;
}
.buy_containers {
  padding: 30px 30px 60px 30px;
}
.buy_title {
  font-size: 22px;
  line-height: 40px;
  border-bottom: 1px dashed #a8a8a8;
}

.buy_detail {
  position: relative;
  min-height: 460px;
  width: 850px;

  margin: 0 auto;
}

.contactUs {
  height: 47px;
  line-height: 47px;
  width: 198px;
  text-align: center;
  background-color: #cb4848;
  color: #fff;
  border-radius: 23px;
  margin: 102px auto 0 auto;
}

.yuyue {
  /* height: 330px; */
  background: #fef8f5;
  padding: 20px 125px;
  margin-bottom: 10px;
  margin-left: 37px;
  width: 500px;
}
.yuyue input {
  margin: 10px 0;
}
.yuyue h3 {
  text-align: center;

  font-size: 20px;
  line-height: 25px;
  color: #7f8080;
  padding-top: 15px;
}
.yuyue p {
  font-size: 16px;
  line-height: 30px;
  color: #bc734d;
  margin-bottom: 15px;
}
.yuyue input {
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  padding-left: 10px;
  outline: none;
  border: none;
  font-size: 16px;
  width: 320px;
}
.yuyue h4 {
  width: 85px;
  letter-spacing: 5px;
  line-height: 40px;
  height: 40px;
  margin-left: 10px;
  display: inline-block;
  text-align: right;
  padding-right: 8px;
}
.shengfen {
  width: 140px;
  display: inline-block;
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  line-height: 30px;
  padding-left: 10px;
  letter-spacing: 2px;
}
.selectt {
  width: 30px;
  height: 30px;
  background: url(../../assets/img/xia.png) no-repeat;
  color: white;
  float: right;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.xiala {
  width: 150px;
  float: right;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  height: 100px;
  overflow-y: scroll;
}
.xiala li {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
}
.xiala li:hover {
  background: #ffeded;
}
.sub {
  width: 100px;
  background: #a45544;
  border-radius: 10px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
  color: white;
  margin-top: 15px;
  cursor: pointer;
}
/* input:-internal-autofill-selected{
    background: white;
  } */
input:-internal-autofill-selected {
  background: black;
}
.buytable td {
  border: 1px solid #e6e4e4;
}
.buytable img {
  position: absolute;
  /* margin-left: 6px; */
  margin-bottom: 4px;
}
.zhu {
  background: #a7152e;
  margin-top: 20px;
  color: white;
  padding-left: 7px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  width: 50px;
  border-radius: 0 20px 20px 0;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #666;
  letter-spacing: 1px;
  /* text-indent: 2em; */
  /* padding-left: 37px; */
}
.zhushia {
  /* padding-left: 15px; */
}
.lianjie {
  margin-top: 60px;
  padding-bottom: 60px;
  text-align: right;
  width: 840px;
}
.buylianjie {
  background: #f2ae47;
  display: inline-block;
  width: 150px;
  height: 40px;
  margin-left: 10px;
  line-height: 40px;
  text-align: center;
  border-radius: 5px;
}
.buylianjie a {
  text-decoration: none;
}
.num_text {
  color: #b83616;
  font-size: 16px;
  /* margin-left: 20px; */
}
.txt_l {
  height: 29px;
  line-height: 29px;
}
.yuanchaung{
  position: absolute;
  top: -14px;
  left: -15px;
  /* width: 24px; */
}
.jiabcen{
  padding: 10px 0;
  text-align: center;
  padding-left: 0 !important;
}
.tipsss{
  border:1px solid #e6e4e4;
  border-top:none;
  padding: 20px;
}
td:has(.heng){
  vertical-align: middle;
}
sup.heng {
  display: inline-block;
  height: 0;
  width: 10px;
  border-bottom: 1px solid #4d4d4d;
  position: relative;
  top: -3px;
}
</style>